import styled from 'styled-components';

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  button {
    svg {
      height: 22px;
    }

    &:hover {
      color: var(--color-text-muted);
    }
  }
`;
